import { FormEvent, useState } from "react";

import classNames from "classnames";
import css from "./Login.module.css";
import logoUrl from "../../images/cs-logo.svg";
import { parseSearchParams } from "../../utils/url";
import { useAuth0 } from "@auth0/auth0-react";
import { useAuthState } from "../../context/auth";

type UrlParams = {
  showAuth0Login: boolean;
};

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showLoginError, setShowLoginError] = useState(false);

  const { login } = useAuthState();
  const auth0 = useAuth0();
  const params: UrlParams = parseSearchParams((x) => ({
    showAuth0Login:
      x.has("showAuth0Login") && x.get("showAuth0Login") !== "false",
  }));

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setShowLoginError(false);
    try {
      await login(username, password);
    } catch {
      setShowLoginError(true);
    }
  };

  return (
    <div className={`text-center`}>
      {showLoginError && (
        <div
          className={classNames(
            "alert alert-danger text-start",
            css["login-error"],
          )}
          role="alert"
        >
          There was a problem with your username or password. Try logging in
          again and if you need further assistance accessing your account, email{" "}
          <a href="mailto:support@civicscience.com">support@civicscience.com</a>
        </div>
      )}
      <main className={classNames(css["form-login"])}>
        <form onSubmit={handleSubmit}>
          <img
            className="mb-4"
            src={logoUrl}
            alt="CivicScience"
            width="72"
            height="72"
          />
          <h1 className="h3 mb-3 fw-normal">Please sign in</h1>
          <div className="form-floating">
            <input
              id="email"
              className="form-control"
              type="email"
              placeholder="user@domain.com"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <label className="form-label" htmlFor="email">
              Email address
            </label>
          </div>
          <div className="form-floating">
            <input
              id="password"
              className="form-control"
              type="password"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label className="form-label" htmlFor="password">
              Password
            </label>
          </div>
          <button className="w-100 btn btn-lg btn-primary" type="submit">
            Sign in
          </button>
          {params.showAuth0Login && (
            <button
              className="w-100 btn btn-lg btn-secondary my-2"
              type="button"
              onClick={() => auth0.loginWithRedirect()}
            >
              Sign in Auth0
            </button>
          )}
        </form>
      </main>
    </div>
  );
};

export default Login;
